import TemplateView from '../../TemplateView'
import messageResource from '../../messageResource'
import Dropzone from 'dropzone'
import CustomCheckbox from '../../components/customCheckbox/CustomCheckbox'
import {CustomCheckBoxSize} from '../../components/customCheckbox/constants'
import {DROPZONE_PARAMETERS} from './constants'

export default class LogoDropzone extends TemplateView {
    constructor({
        onFileLoaded = () => {},
        onShowBackgroundChange = (checked) => {},
        onCreateThumbnail = (url) => {},
    } = {}) {
        super()

        this.callbacks = {
            onFileLoaded,
            onShowBackgroundChange,
            onCreateThumbnail,
        }

        this.state = {
            active: false,
            showBackground: false,
            imageUrl: '',
        }

        this.onStatePropertyChanged('active', (active) => {
            this.getEl().toggleClass('active', active)
            this.showBackroundCheckbox.setState({disabled: !active})
        })

        this.onStatePropertyChanged('imageUrl', (imageUrl) => {
            this.$logoPreviewImg.attr('src', imageUrl)
            this.getEl().toggleClass('hasFile', !!imageUrl)
            this.$logoPreview.toggle(!!imageUrl)

        })

        this.onStatePropertyChanged('showBackground', (showBackground) => {
            this.getEl().toggleClass('logoWithBackground', showBackground)
            this.showBackroundCheckbox.setState({checked: showBackground})
        })
    }

    templateHtml() {
        return '        <div class="logoDropzone">' +
               '            <div class="placeholder dropzoneClickable">' +
               '                <div class="image"/>' +
               '                <div class="text"><%=placeholderText%></div>' +
               '            </div>' +
               '            <div class="useWhiteBgCheckbox"/>' +
               '            <div class="logoPreview">' +
               '                <div class="logoDetails">' +
               '                    <img class="currentLogo"/>' +
               '                </div>' +
               '            </div>' +
               '            <div class="logoDropzonePreviewTemplate dz-preview dz-file-preview"><div/></div>' +
               '            <div class="uploadAnotherImageButton"><%=uploadAnother%></div>' +
               '        </div>'
    }

    messageKeys() {
        return {
            placeholderText: 'logo_settings.dropzone.placeholder_text',
            uploadAnother: 'logo_settings.dropzone.upload_another',
        }
    }

    afterRender() {
        this.$logoPreview = this.find('.logoPreview')
        this.$logoPreviewImg = this.find('.currentLogo')
        this.find('.logoDropzonePreviewTemplate').hide() // dropzone preview not used here
        this._initDropzone()
        this.showBackroundCheckbox = new CustomCheckbox({
            label: messageResource.getMessage('logo_settings.dropzone.use_white_bg'),
            size: CustomCheckBoxSize.LITTLE,
            onChange: ({checked}) => this.callbacks.onShowBackgroundChange(checked),
        }).init(this.find('.useWhiteBgCheckbox'))
        this.find('.uploadAnotherImageButton').on('click', () => {
            if (this.state.active) this.dropzone.hiddenFileInput.click()
        })

        this.renderInitialState()
    }

    _initDropzone() {
        this.dropzone = new Dropzone('.logoDropzone', {
            previewTemplate: document.querySelector('.logoDropzonePreviewTemplate').innerHTML,
            paramName: 'formCustomInterfaceLogo.logo',
            clickable: '.dropzoneClickable',
            ...DROPZONE_PARAMETERS,
            accept: (file, callback) => {
                if (file.size === 0)
                    callback(messageResource.getMessage('contact_support.error.empty_file'))
                else {
                    if (this.dropzone.files[1] != null) {
                        this.dropzone.removeFile(this.dropzone.files[0])
                    }
                    this.callbacks.onFileLoaded()
                    callback()
                }
            },
        })
        this.dropzone.on('maxfilesexceeded', (file) => {
            this.dropzone.removeFile(this.dropzone.files[0])
            this.dropzone.addFile(file)
        })
        this.dropzone.on('error', (file, error) => {
            this._onDropzoneError(file, error)
        })
        this.dropzone.createThumbnailFromUrl = (file, imageUrl, callback, crossOrigin) => {
            if (file.accepted) {
                this.callbacks.onCreateThumbnail(imageUrl)
            }
            if (callback != null) {
                return callback()
            }
        }
    }

    _onDropzoneError(file, errorText) {
        if (file.status !== 'canceled') {
            alert(errorText)
            this.dropzone.removeFile(file)
        }
    }

    hasFile() {
        return this.dropzone.files && this.dropzone.files.length
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/customization/LogoDropzone.js